import { defineMessages } from 'react-intl';

export const redeemGiftCardScreenMessages = defineMessages({
  screenTitle: {
    defaultMessage: 'Redeem gift card',
    description: 'Redeem Gift Card Screen | Title',
  },
});
